var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHackathon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_100822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 59C46.2924 59 59.5 45.7924 59.5 29.5C59.5 13.2076 46.2924 0 30 0C13.7076 0 0.5 13.2076 0.5 29.5C0.5 45.7924 13.7076 59 30 59Z",
    fill: "url(#paint0_linear_1393_100822)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4847 15.4259V20.6206C36.4847 21.0167 36.4481 21.4036 36.375 21.7799C39.1338 18.5244 39.2846 16.9279 39.0637 16.2181C38.8718 15.6026 38.3036 15.3756 37.8603 15.2934C37.2479 15.1806 36.7101 15.3101 36.4847 15.4259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9859 15.2076V20.6201C24.9859 21.9774 25.5008 23.2159 26.3463 24.1513L26.4255 24.2305C26.4438 24.2488 26.459 24.2671 26.4727 24.2869C27.4339 25.2786 28.7776 25.8955 30.2628 25.8955C31.7481 25.8955 33.0948 25.2786 34.053 24.2853C34.0667 24.2655 34.0834 24.2472 34.1002 24.229L34.1779 24.1498C35.0234 23.2129 35.5383 21.9744 35.5383 20.6171V15.2076V13.7695H24.9844V15.2045V15.2076H24.9859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6644 15.2934C22.2211 15.3756 21.6529 15.6026 21.4609 16.2181C21.2401 16.9279 21.3909 18.5229 24.1497 21.7799C24.0796 21.4051 24.04 21.0167 24.04 20.6206V15.4259C23.8145 15.3101 23.2783 15.1806 22.6644 15.2934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3509 32.9492H27.1953V34.9966H33.3391V32.9492H31.1698H29.3768C29.3692 32.9492 29.3615 32.9492 29.3509 32.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.266 29.9961C29.6369 29.9961 29.125 30.5079 29.125 31.1371C29.125 31.4722 29.2712 31.7876 29.5226 32.0039H31.0109C31.2623 31.7876 31.4085 31.4722 31.4085 31.1371C31.407 30.5079 30.8952 29.9961 30.266 29.9961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6641 26.7799V29.656C39.6641 29.6682 39.6778 29.6819 39.69 29.6819H40.994C41.0077 29.6819 41.0199 29.6682 41.0199 29.656V26.7799C41.0199 26.7677 41.0077 26.754 40.994 26.754H39.69C39.6778 26.7525 39.6641 26.7662 39.6641 26.7799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0312 26.7799V29.656C19.0312 29.6682 19.045 29.6819 19.0571 29.6819H20.3611C20.3749 29.6819 20.387 29.6682 20.387 29.656V26.7799C20.387 26.7677 20.3749 26.754 20.3611 26.754H19.0571C19.045 26.7525 19.0312 26.7662 19.0312 26.7799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9609 11.1497V36.9494C10.9609 37.6608 11.5398 38.2397 12.2512 38.2397H25.0125H35.0347H47.796C48.5074 38.2397 49.0862 37.6608 49.0862 36.9494V11.1497C49.0862 10.4383 48.5074 9.85938 47.796 9.85938H12.2512C11.5413 9.85938 10.9609 10.4383 10.9609 11.1497ZM25.6751 24.8204C21.6915 20.82 19.9701 17.8312 20.5581 15.9391C20.8141 15.1196 21.5194 14.5437 22.4943 14.364C22.9757 14.2756 23.5531 14.2863 24.0406 14.4188V13.7287C24.0406 13.2306 24.4473 12.8223 24.947 12.8223H35.5816C36.0813 12.8223 36.488 13.2306 36.488 13.7287V14.4188C36.9755 14.2863 37.5528 14.2756 38.0342 14.364C39.0107 14.5437 39.716 15.118 39.9704 15.9391C40.56 17.8312 38.8386 20.8185 34.8549 24.8188C33.816 25.9537 32.3627 26.7048 30.7373 26.8282V29.1041C31.662 29.3189 32.3521 30.1491 32.3521 31.1378C32.3521 31.4409 32.2866 31.7364 32.1632 32.0046H33.8084C34.0704 32.0046 34.2806 32.2163 34.2806 32.4783V35.4717C34.2806 35.7338 34.0689 35.944 33.8084 35.944H26.7186C26.4566 35.944 26.2464 35.7322 26.2464 35.4717V32.4783C26.2464 32.2163 26.4581 32.0061 26.7186 32.0061H28.3639C28.242 31.738 28.175 31.444 28.175 31.1393C28.175 30.1506 28.8651 29.3204 29.7898 29.1056V26.8282C28.1658 26.7048 26.7126 25.9553 25.6751 24.8204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0327 45.5898H25.0105H23.4323C22.4146 45.5898 21.5859 46.4186 21.5859 47.4362V48.6884C21.5859 49.0159 21.8525 49.2825 22.1801 49.2825H37.8646C38.1922 49.2825 38.4587 49.0144 38.4587 48.6884V47.4362C38.4587 46.4186 37.63 45.5898 36.6124 45.5898H35.0327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4844 39.1836H34.5606V44.6418H25.4844V39.1836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1393_100822",
    x1: 0.5,
    y1: 29.5,
    x2: 59.5,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B306C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_100822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHackathon);
export default __webpack_public_path__ + "static/media/icon-hackathon.02bc7a2b402812bff18bc335b1b2369e.svg";
export { ForwardRef as ReactComponent };